import { getConfig } from '../lib/config';
import { setBoundingBox } from '../lib/utils';
import { stateInfoRequest } from '../lib/request';

export const reverseGeocode = (location) => {
  const path = getConfig('REVERSE_GEOCODE_SERVICE');
  const params = {
    f: 'json',
    location,
  }

  return stateInfoRequest('get', path , params);
};

export const stateInfo = (point, radius) => {
  const serviceUrl = getConfig('BASEMAPS_SERVICE');
  const path = serviceUrl + '/County/MapServer/0/query'

  const boundingBox = setBoundingBox(point, radius)
  const params = {
    f: 'json',
    geometry: { ...boundingBox, spatialReference: { wkid: 102100 } },
    geometryType: 'esriGeometryEnvelope',
    outFields: '*',
    returnGeometry: 'false',
    spatialRel: 'esriSpatialRelIntersects',
  }

  return stateInfoRequest('get', path , params);
};

